import React from 'react';
const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
            Welcome to RDS <span className="text-orange-600"> Group of Colleges</span>
          </h1>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-blue-800 border-b-4 border-orange-500 pb-2 inline-block">
                Welcome to RDS Group of Colleges
              </h2>
              <p className="text-gray-700 leading-relaxed">
                The RDS Group of Colleges is an integrated multi-disciplinary institute. It provides a wide and varied platform for the students with academic and extracurricular talent. We are committed to develop a student-centered environment to meet the intellectual, cultural, social, physical, and recreational needs of the students. The management consistently works forwards providing value-added resources and infrastructure to impart excellent education using modern teaching techniques.
              </p>
              <p className="text-gray-700 leading-relaxed">
                We are an organization that combines the latest developments in the field of education with our scientific and operational skills to create an environment which nurtures and encourages the aspirations of students. Our faculty and staff have, come with innovative methods in teaching to construct new knowledge in the classroom and make the subject interesting.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Our motto is always to give our students the best of what is happening in an around so that there always at the cutting edge of academics in any place in the world. We are confident that RDS Group of Studies will meet your aspirations and we shall be able to meet our objectives and prepare our students as globally proficient and accountable citizens.
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-8 border-t-4 border-orange-500">
              <h3 className="text-2xl font-bold text-blue-800 mb-6 text-center">Enquiry Form</h3>
              <form className="space-y-5">
                <div>
                  <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-1">
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    placeholder="Enter Full Name"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition duration-200 outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter Email"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition duration-200 outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    placeholder="Enter Phone Number"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition duration-200 outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="course" className="block text-sm font-medium text-gray-700 mb-1">
                    Course Detail
                  </label>
                  <input
                    type="text"
                    id="course"
                    placeholder="Enter Course Detail"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition duration-200 outline-none"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-blue-600 to-orange-500 text-white font-semibold py-3 px-6 rounded-lg hover:shadow-lg transform hover:scale-105 transition duration-300"
                >
                  Submit Enquiry
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;